module.exports = __webpack_public_path__ + "fonts/Vonnes-BlackComp.95e8a35e.otf";